import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "toast" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"__resource_preload\"><div class=\"__resource_preload-offline\"></div><div class=\"__resource_preload-exception\"></div><div class=\"__resource_preload-empty\"></div><div class=\"__resource_preload-404\"></div><i class=\"icomoon-close icon-close\"></i></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_FooterBar = _resolveComponent("FooterBar")!
  const _component_BTResultPop = _resolveComponent("BTResultPop")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_FileTreeDialog = _resolveComponent("FileTreeDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createVNode(_component_Header, null, null, 512), [
      [_vShow, _ctx.showHead]
    ]),
    _createVNode(_component_router_view),
    _createVNode(_component_FooterBar),
    _createVNode(_component_BTResultPop),
    _withDirectives(_createVNode(_component_Dialog, null, null, 512), [
      [_vShow, _ctx.show]
    ]),
    _createVNode(_component_FileTreeDialog, {
      "yunpan-fetch": false,
      type: "2"
    }),
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", null, _toDisplayString(_ctx.toast.message), 1)
    ], 512), [
      [_vShow, _ctx.toast.message]
    ]),
    _hoisted_2
  ], 64))
}